import { makeAutoObservable } from 'mobx'
import { showToast } from 'shared/ui'
import { logger } from 'shared/lib'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { TeamsApi } from 'entities/Teams/api/teams'
import { DeleteTeamModalActions } from 'entities/Teams/ui/DeleteTeamModal/ui/DeleteTeamModalActions'

export class DeleteTeamModalStore {
  private _deleting = false

  constructor(
    private _id: number,
    private _isIntegrationTeam: boolean,
    private _onSuccess?: (id: number) => void | Promise<void>
  ) {
    this.openDeleteModal()
    makeAutoObservable(this)
  }

  get deleteModalId() {
    return 'deleteTeam_modal'
  }

  get deleting() {
    return this._deleting
  }

  handleDeleteTeam = async (id: number) => {
    try {
      this._deleting = true
      await this.deleteTeam(id)
      modalStore.closeModal(this.deleteModalId)
    } catch (error) {
      logger.error(error)
    } finally {
      this._deleting = false
    }
  }

  closeDeleteModal = () => {
    modalStore.closeModal(this.deleteModalId)
  }

  openDeleteModal = () => {
    modalStore.addModal({
      id: this.deleteModalId,
      type: ModalTypeList.ALERT,
      title: 'Delete team?',
      desc: this._isIntegrationTeam
        ? 'This will remove the team and unassign anything connected to it. Existing conversations, data, and team on HubSpot won’t be deleted. This action cannot be undone.'
        : 'This will remove the team and unassign anything connected to it. Existing conversations, data, and members won’t be deleted. This action cannot be undone.',
      ModalActions: DeleteTeamModalActions,
      ModalContentProps: {
        store: this,
        id: this._id,
      },
    })
  }

  deleteTeam = async (id: number) => {
    try {
      await TeamsApi.deleteTeam(id)
      this._onSuccess?.(id)
      showToast({ type: 'success', title: 'Team deleted' })
    } catch (error) {
      logger.error(error)
      showToast({ type: 'error', title: 'Failed to delete team. Please try again.' })
    }
  }
}
